"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.standardUtilitiesRaw = exports.network = exports.ROUTE = void 0;
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const axios_1 = __importDefault(require("axios"));
const lodash_es_1 = require("lodash-es");
const root_navigation_1 = require("../navigation/root_navigation");
const SharedPropsService_1 = __importDefault(require("../SharedPropsService"));
const types_1 = require("@voltmoney/types");
const react_native_1 = require("react-native");
const lodash_1 = __importDefault(require("lodash"));
const clipboard_1 = __importDefault(require("@react-native-clipboard/clipboard"));
const utils_1 = require("./utils");
const analytics_react_native_1 = require("@amplitude/analytics-react-native");
const analytics_react_native_2 = require("@amplitude/analytics-react-native");
const amplitude_js_1 = __importDefault(require("amplitude-js"));
const prevPayload = { current: {} };
let screenHeight = 0;
exports.ROUTE = {
    ALERT_PAGE: "ALERT_PAGE",
    SPLASH_SCREEN: "SPLASH_SCREEN",
    TEST_PAGE: "TEST_PAGE",
    PHONE_NUMBER: "PHONE_NUMBER",
    ENTER_EMAIL: "ENTER_EMAIL",
    OTP_VERIFY: "OTP_VERIFY",
    EMAIL_VERIFY: "EMAIL_VERIFY",
    KYC_PAN_VERIFICATION: "KYC_PAN_VERIFICATION",
    PAN_CONFIRM_NAME: "PAN_CONFIRM_NAME",
    MF_FETCH_PORTFOLIO: "MF_FETCH_PORTFOLIO",
    UPDATE_PHONE_NUMBER: "UPDATE_PHONE_NUMBER",
    UPDATE_EMAIL_ID: "UPDATE_EMAIL_ID",
    OTP_AUTH_CAS: "OTP_AUTH_CAS",
    VERIFICATION_FAILED: "VERIFICATION_FAILED",
    KYC_AADHAAR_VERIFICATION: "KYC_AADHAAR_VERIFICATION",
    KYC_AADHAAR_VERIFICATION_OTP: "KYC_AADHAAR_VERIFICATION_OTP",
    KYC_SUMMARY: "KYC_SUMMARY",
    BANK_ACCOUNT_VERIFICATION: "BANK_ACCOUNT_VERIFICATION",
    BANK_SELECT: "BANK_SELECT",
    BANK_ACCOUNT_ADD: "BANK_ACCOUNT_ADD",
    BANK_SEARCH_BRANCH: "BANK_BRANCH_SEARCH",
    KYC_STEPPER: "KYC_STEPPER",
    POPUP_LOADER: "POPUP_LOADER",
    KYC_DIGILOCKER: "KYC_DIGIO_DIGILOCKER",
    KYC_PHOTO_VERIFICATION: "KYC_PHOTO_VERIFICATION",
    CAMERA_CAPTURE: "CAMERA_CAPTURE",
    PLEDGE_CONFIRMATION_LOADING: "PLEDGE_CONFIRMATION_LOADING",
    MF_PLEDGE_PORTFOLIO: "MF_PLEDGE_PORTFOLIO",
    PLEDGE_VERIFY: "PLEDGE_VERIFY",
    PLEDGE_LOADING: "PLEDGE_LOADING",
    UNLOCK_SUCCESS: "UNLOCK_SUCCESS",
    PLEDGE_CONFIRMATION: "PLEDGE_CONFIRMATION",
    ASSET_PLEDGE: "ASSET_PLEDGE",
    MODIFY_LIMIT: "MODIFY_LIMIT",
    PORTFOLIO: "PORTFOLIO",
    PLEDGED_AMOUNT: "PLEDGED_AMOUNT",
    MODIFY_PLEDGED_AMOUNT: "MODIFY_PLEDGED_AMOUNT",
    DASHBOARD: "DASHBOARD",
    WITHDRAW_AMOUNT: "WITHDRAW_AMOUNT",
    WITHDRAWAL_OTP: "WITHDRAWAL_OTP",
    WITHDRAWAL_SUCCESS: "WITHDRAWAL_SUCCESS",
    REPAYMENT: "REPAYMENT",
    LOAN_REPAYMENT: "LOAN_REPAYMENT",
    LOAN_WEBVIEW: "LOAN_WEBVIEW",
    LOAN_AUTOPAY: "LOAN_AUTOPAY",
    LOAN_AGREEMENT: "LOAN_AGREEMENT",
    AGREEMENT_WEBVIEW: "AGREEMENT_WEBVIEW",
    ACCOUNT_DETAILS: "ACCOUNT_DETAILS",
    CONTACT_US: "CONTACT_US",
    MY_PROFILE: "MY_PROFILE",
    FAQ: "FAQ",
    ABOUTUS: "ABOUTUS",
    FAQ_DETAILS: "FAQ_DETAILS",
    CAROUSAL_PAGE: "CAROUSAL_PAGE",
    LANDING_PAGE: "LANDING_PAGE",
    TRANSACTIONS: "TRANSACTIONS",
    PRIVACY_POLICY: "PRIVACY_POLICY",
    KYC_ADDITIONAL_DETAILS: "KYC_ADDITIONAL_DETAILS",
    KYC_DOCUMENT_UPLOAD: "KYC_DOCUMENT_UPLOAD",
    UNLOCK_LIMIT_LANDING: "UNLOCK_LIMIT_LANDING",
    DIST_BANK_ACCOUNT_ADD: "DIST_BANK_ACCOUNT_ADD",
    DIST_BANK_ACCOUNT_VERIFICATION: "DIST_BANK_ACCOUNT_VERIFICATION",
    DIST_BANK_SEARCH_BRANCH: "DIST_BANK_SEARCH_BRANCH",
    DIST_BANK_SELECT: "DIST_BANK_SELECT",
    DISTRIBUTOR_PORTFOLIO: "DISTRIBUTOR_PORTFOLIO",
    PORTFOLOIO_START: "PORTFOLOIO_START",
    SELECT_DISTRIBUTOR_PORTFOLIO: "SELECT_DISTRIBUTOR_PORTFOLIO",
    INVESTOR: "INVESTOR",
    ENTER_NAME: "ENTER_NAME",
    DISTRIBUTOR_CLIENT_LIST: "DISTRIBUTOR_CLIENT_LIST",
    DISTRIBUTOR_CLIENT_LIST_STEPPER: "DISTRIBUTOR_CLIENT_LIST_STEPPER",
    DISTRIBUTOR_BASIC_DETAILS_INFO: "DISTRIBUTOR_BASIC_DETAILS_INFO",
    VERIFICATION_FAILED_NEW: "VERIFICATION_FAILED_NEW",
    PORTFOLIO_READONLY: "PORTFOLIO_READONLY",
    SET_CREDIT_LIMIT: "SET_CREDIT_LIMIT",
    PLEDGE_CONFIRMATION_NEW: "PLEDGE_CONFIRMATION_NEW",
    UPDATE_SLIDER_AMOUNT: "UPDATE_SLIDER_AMOUNT",
    KYC_DOCUMENT_UPLOAD_POA: "KYC_DOCUMENT_UPLOAD_POA",
    KYC_DOCUMENT_UPLOAD_POI: "KYC_DOCUMENT_UPLOAD_POI",
    LOAN_AGREEMENT_POLLING: "LOAN_AGREEMENT_POLLING",
    MANAGE_LIMIT: "MANAGE_LIMIT",
    SELECT_SOURCE: "SELECT_SOURCE",
    SET_CREDIT_LIMIT2: "SET_CREDIT_LIMIT2",
    // SET_CREDIT_LIMIT2: "SET_CREDIT_LIMIT2",
    PORTFOLIO_FROM_RTA: "PORTFOLIO_FROM_RTA",
    DETAILS_CONFIRM: "DETAILS_CONFIRM",
    BASIC_DETAILS_START: "BASIC_DETAILS_START",
    CHECK_PARTNER_LIMIT: "CHECK_PARTNER_LIMIT",
    OTP_PARTNER_PORTFOLIO: "OTP_PARTNER_PORTFOLIO",
    PARTNER_MOBILE_UPDATE: "PARTNER_MOBILE_UPDATE",
    PARTNER_EMAIL_UPDATE: "PARTNER_EMAIL_UPDATE",
    CHECKING_LIMIT: "CHECKING_LIMIT",
    PORTFOLIO_UNLOCK: "PORTFOLIO_UNLOCK",
    INTRO_PAGE: 'INTRO_PAGE',
    PARTNER_DASHBOARD: 'PARTNER_DASHBOARD',
    PARTNER_ACTIVE_CUSTOMER: 'PARTNER_ACTIVE_CUSTOMER',
    PARTNER_LEAD: 'PARTNER_LEAD',
    PARTNER_REFERRED_PARTNER: 'PARTNER_REFERRED_PARTNER',
    PARTNER_LED_JOURNEY: 'PARTNER_LED_JOURNEY',
    VOLT_APP: 'VOLT_APP',
    DIGIO_AGREEMENT_SIGN: "DIGIO_AGREEMENT_SIGN",
    DIGIO_MANDATE_SIGN: 'DIGIO_MANDATE_SIGN',
    REGISTER_LEADS: 'REGISTER_LEADS',
    REGISTER_LEADS_SUCCESS: 'REGISTER_LEADS_SUCCESS',
    PAYMENT_START: 'PAYMENT_START',
    PAYMENT_CALLBACK: 'PAYMENT_CALLBACK',
    KYC_DOCUMENTS_UPLOAD_POA_MANUAL: 'KYC_DOCUMENTS_UPLOAD_POA_MANUAL',
    KYC_DOCUMENTS_UPLOAD_POI_MANUAL: 'KYC_DOCUMENTS_UPLOAD_POI_MANUAL',
    KYC_DOCUMENTS_UPLOAD_BASE: 'KYC_DOCUMENTS_UPLOAD_BASE',
    KYC_DOCUMENTS_DIGIO_BASE: 'KYC_DOCUMENTS_DIGIO_BASE',
    CO_BORROWER_LANDING: 'CO_BORROWER_LANDING',
    CO_BORROWER_PAN: 'CO_BORROWER_PAN',
    CO_BORROWER_KYC_DOCUMENTS_UPLOAD_BASE: 'CO_BORROWER_KYC_DOCUMENTS_UPLOAD_BASE',
    CO_BORROWER_DOCUMENTS_UPLOAD_POA_MANUAL: 'CO_BORROWER_DOCUMENTS_UPLOAD_POA_MANUAL',
    CO_BORROWER_DOCUMENTS_UPLOAD_POI_MANUAL: 'CO_BORROWER_DOCUMENTS_UPLOAD_POI_MANUAL',
    CO_BORROWER_ADDITIONAL_DETAILS: 'CO_BORROWER_ADDITIONAL_DETAILS',
    CO_BORROWER_SUMMARY: 'CO_BORROWER_SUMMARY',
    CO_BORROWER_SUMMARY_CONFIRM: 'CO_BORROWER_SUMMARY_CONFIRM',
    CO_BORROWER_PAN_CONFIRM_NAME: 'CO_BORROWER_PAN_CONFIRM_NAME',
    CO_BORROWER_KYC_DIGIO_BASE: 'CO_BORROWER_KYC_DIGIO_BASE',
    PAYMENT_LOADER: 'PAYMENT_LOADER',
    JOINT_HOLDER_NOTIFY: 'JOINT_HOLDER_NOTIFY',
    ASK_MUTUAL_FUND: 'ASK_MUTUAL_FUND',
    NO_MUTUAL_FUND_INSTRUCTION: 'NO_MUTUAL_FUND_INSTRUCTION',
    DIGIO_MODAL: 'DIGIO_MODAL',
    ASK_MUTUAL_FUND_OLD: 'ASK_MUTUAL_FUND_OLD',
    PARTNER_SIGNUP: 'PARTNER_SIGNUP',
    EMPANEL_SUCCESS_MODAL: 'EMPANEL_SUCCESS_MODAL',
    PARTNER_DASHBOARD_V2: 'PARTNER_DASHBOARD_V2',
    INVITE_CLIENT: 'INVITE_CLIENT',
    PARTNER_LOGOUT: 'PARTNER_LOGOUT',
    PARTNER_MENU: 'PARTNER_MENU',
    COLLATERAL: 'COLLATERAL',
    DEMO_VIDEOS: 'DEMO_VIDEOS',
    MY_ACCOUNT: 'MY_ACCOUNT',
    PARTNER_VIEW_DETAIL_LEAD: 'PARTNER_VIEW_DETAIL_LEAD',
    PLATFORM_DASHBOARD: 'PLATFORM_DASHBOARD',
    PLATFORM_LEADS: 'PLATFORM_LEADS',
    PLATFORM_ACTIVE_CUSTOMERS: 'PLATFORM_ACTIVE_CUSTOMERS',
    PLATFORM_LINKED_PARTNERS: 'PLATFORM_LINKED_PARTNERS',
    PLATFORM_SIGN_UP: 'PLATFORM_SIGN_UP',
    PLATFORM_VIEW_DETAILS: 'PLATFORM_VIEW_DETAILS',
    PLATFORM_LOG_OUT: 'PLATFORM_LOG_OUT',
    MARKETING_LEAD: 'MARKETING_LEAD',
    MARKETING_LEAD_OTP: 'MARKETING_LEAD_OTP',
    MARKETING_LEAD_REDIRECT: 'MARKETING_LEAD_REDIRECT',
    KYC_DIGIO_RESPONSE: 'KYC_DIGIO_RESPONSE',
    DIGIO_AUTOPAY_INPROGRESS: 'DIGIO_AUTOPAY_INPROGRESS',
    DIGIO_AUTOPAY_REDIRECTION: 'DIGIO_AUTOPAY_REDIRECTION',
    DIGIO_AUTOPAY_FAILURE: 'DIGIO_AUTOPAY_FAILURE',
    CONTACT_US_CARD: 'CONTACT_US_CARD',
    CHECK_LIMIT_MFC_INIT: 'CHECK_LIMIT_MFC_INIT',
    CHECK_LIMIT_MFC_OTP: 'CHECK_LIMIT_MFC_OTP',
    CHECK_LIMIT_LOADING: 'CHECK_LIMIT_LOADING',
    CHECK_LIMIT_SUCCESS: 'CHECK_LIMIT_SUCCESS',
    CHECK_LIMIT_VIEW_DETAIL: 'CHECK_LIMIT_VIEW_DETAIL',
    CHECK_LIMIT_NO_MF: 'CHECK_LIMIT_NO_MF',
    CHECK_LIMIT_INFO: 'CHECK_LIMIT_INFO',
    CHECK_LIMIT_ALERT_MODAL: 'CHECK_LIMIT_ALERT_MODAL',
    PARTNER_CHECK_LIMIT: 'PARTNER_CHECK_LIMIT',
    EARNING: 'EARNING',
    PARTNER_AUTH: 'PARTNER_AUTH',
    EMAIL_STATEMENT: 'EMAIL_STATEMENT',
    DIGIO_MODAL_CO_BORROWER: 'DIGIO_MODAL_CO_BORROWER',
    PARTNER_CHECK_CUSTOMER_PORFOLIO: 'PARTNER_CHECK_CUSTOMER_PORFOLIO',
    APPLICATION_PENDING_BLOCKING_SCREEN: 'APPLICATION_PENDING_BLOCKING_SCREEN',
    CHECK_CUSTOMER_ELIGIBILITY: 'CHECK_CUSTOMER_ELIGIBILITY',
    DIGIO_AGREEMENT_INPROGRESS: 'DIGIO_AGREEMENT_INPROGRESS',
    DIGIO_AGREEMENT_FAILED: 'DIGIO_AGREEMENT_FAILED',
    KFS_SCREEN: 'KFS_SCREEN',
    CREDIT_LOADING_SCREEN: 'CREDIT_LOADING_SCREEN',
    NAME_MISMATCH: 'NAME_MISMATCH',
    CIBIL_CHECK_LOADING_SCREEN: 'CIBIL_CHECK_LOADING_SCREEN',
    SIGN_DESK_ESIGN: 'SIGN_DESK_ESIGN',
    EMAIL_VERIFY_OTP: 'EMAIL_VERIFY_OTP',
    MANDATE_MODAL: "MANDATE_MODAL",
    DIGIO_DOC_MODAL: "DIGIO_DOC_MODAL",
    BORROWER_LANDING_SCREEN: 'BORROWER_LANDING_SCREEN',
    LOGOUT_SCREEN: 'LOGOUT_SCREEN',
    BAJAJ_DIGIO_KYC_MODAL: 'BAJAJ_DIGIO_KYC_MODAL',
    BAJAJ_DIGIO_CO_BORROWER_KYC_MODAL: 'BAJAJ_DIGIO_CO_BORROWER_KYC_MODAL',
    SUPPORTING_DOCUMENT: 'SUPPORTING_DOCUMENT',
    PHOTO_MISMATCH: 'PHOTO_MISMATCH',
    UPI_IN_PROGRESS: 'UPI_IN_PROGRESS',
    PAYMENT_OPTIONS: 'PAYMENT_OPTIONS',
    STATE_SELECTION: 'STATE_SELECTION',
    FAILED_SCREEN: 'FAILED_SCREEN',
    VIEW_PORTFOLIO_DETAIL: 'VIEW_PORTFOLIO_DETAIL',
    UNPLDEGE_FUNDS: 'UNPLEDGE_FUNDS',
    UNPLEDGE_STATUS: 'UNPLEDGE_STATUS',
    FORECLOSURE: "FORECLOSURE",
    OUTSTANDING_DUES: "OUTSTANDING_DUES",
    ASSET_PLEDGE_V2: "ASSET_PLEDGE_V2",
    REFRESH_FETCH_OTP: "REFRESH_FETCH_OTP",
    COLLATERAL_INTRO_CARD: 'COLLATERAL_INTRO_CARD',
    COLLATERAL_DOWNLOAD_INFO: 'COLLATERAL_DOWNLOAD_INFO',
    PREVIEW_COLLATERAL: 'PREVIEW_COLLATERAL',
    COLLATERAL_LANGUAGE_SELECT: 'COLLATERAL_LANGUAGE_SELECT',
    USER_CONTEXT_500: 'USER_CONTEXT_500',
    PAYMENT_IN_PROGRESS: 'PAYMENT_IN_PROGRESS',
    BAJAJ_AGREEMENT_STEPPER: 'BAJAJ_AGREEMENT_STEPPER',
    BAJAJ_KFS: 'BAJAJ_KFS',
    REVIEW_AGREEMENT_STEPPER: 'REVIEW_AGREEMENT_STEPPER',
    MANAGE_LIMIT_LANDING: 'MANAGE_LIMIT_LANDING',
    VERIFY_INTEREST_CHARGES_ENHANCE_LIMIT: 'VERIFY_INTEREST_CHARGES_ENHANCE_LIMIT',
    PRE_DASHBOARD_SCREEN: 'PRE_DASHBOARD_SCREEN',
    LOAN_RENEWAL_LEARN_MORE_PAGE: 'LOAN_RENEWAL_LEARN_MORE_PAGE',
    LOAN_RENEWAL_LANDING_PAGE: 'LOAN_RENEWAL_LANDING_PAGE',
    LOAN_RENEWAL_VERIFY_SUMMARY_PAGE: 'LOAN_RENEWAL_VERIFY_SUMMARY_PAGE',
    LOAN_RENEWAL_STATUS_PAGE: 'LOAN_RENEWAL_STATUS_PAGE',
    CONFIRM_AMOUNT: 'CONFIRM_AMOUNT',
    WITHDRAW_REQUEST: 'WITHDRAW_REQUEST',
    REPAYMENT_CHARGES_DETAILS_PAGE: 'REPAYMENT_CHARGES_DETAILS_PAGE',
    INTEREST_REPAYMENT_DETAILS: "INTEREST_REPAYMENT_DETAILS",
    INTEREST_REPAYMENT_LEARN_MORE: "INTEREST_REPAYMENT_LEARN_MORE",
    CGTC_INIT: 'CGTC_INIT',
    CGTC_OTP: 'CGTC_OTP',
    CGTC_PROGRESS: 'CGTC_PROGRESS',
    CGTC_SUMMARY: 'CGTC_SUMMARY',
    CGTC_NO_PORTFOLIO: 'CGTC_NO_PORTFOLIO',
    PARTNER_CAPITAL_GAIN: 'PARTNER_CAPITAL_GAIN',
    TRACK_FORECLOSURE: 'TRACK_FORECLOSURE',
    REMOVE_PLEDGE_STEPS: 'REMOVE_PLEDGE_STEPS',
    PLEDGE_HISTORY: 'PLEDGE_HISTORY',
    PLEDGE_DETAILS: 'PLEDGE_DETAILS',
    SHORTFALL_DETAILS_SCREEN: 'SHORTFALL_DETAILS_SCREEN',
    SHORTFALL_INFO_SCREEN: 'SHORTFALL_INFO_SCREEN',
    SHORTFALL_REPAY_SCREEN: 'SHORTFALL_REPAY_SCREEN',
    SHORTFALL_RECOMENDED_REPAY_SCREEN: 'SHORTFALL_RECOMENDED_REPAY_SCREEN',
    PHONE_PAY_PAGE: "PHONE_PAY_PAGE",
    KYC_DIRECT: 'KYC_DIRECT',
    AS_ES_DOCUMENTS_LISTING: 'AS_ES_DOCUMENTS_LISTING',
    AS_ES_INDIVIDUAL_DOCUMENT: 'AS_ES_INDIVIDUAL_DOCUMENT',
    AS_ES_VIEW_DOCUMENT: 'AS_ES_VIEW_DOCUMENT',
    AS_ES_DOCUMENT_IN_REVIEW: 'AS_ES_DOCUMENT_IN_REVIEW',
    AS_ES_DOCUMENT_REJECTED: 'AS_ES_DOCUMENT_REJECTED',
    AS_ES_SAMPLE_DOCUMENT_VIEW: 'AS_ES_SAMPLE_DOCUMENT_VIEW',
    CONTACT_US_CARD_JUPITER: 'CONTACT_US_CARD_JUPITER',
    CONTACT_US_3_CARDS: 'CONTACT_US_3_CARDS',
    CONTACT_US_2_CARDS: 'CONTACT_US_2_CARDS',
    CONTACT_US_1_CARDS: 'CONTACT_US_1_CARDS',
    PAYOUT_DETAILS_SCREEN: 'PAYOUT_DETAILS_SCREEN',
    IFSC_SECTION_SCREEN: 'IFSC_SECTION_SCREEN',
    INTEREST_CALCULATOR: 'INTEREST_CALCULATOR',
    INTEREST_CALCULATOR_APP: 'INTEREST_CALCULATOR_APP',
    KYC_URL_REDIRECT: 'KYC_URL_REDIRECT',
    CONFIRM_AND_PAYMENT: 'CONFIRM_AND_PAYMENT',
    ELEVATE_LANDING: 'ELEVATE_LANDING',
};
const handleError = (error, modalOptions, callbackBeforeErrorHandle, route, url) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24;
    //Amplitude events for 500 - 599 error code
    if (lodash_1.default.get(error, 'response.status', false) >= 500 &&
        lodash_1.default.get(error, 'response.status', false) <= 599) {
        const routeId = yield async_storage_1.default.getItem("routeId");
        if (routeId && routeId !== '') {
            (0, analytics_react_native_1.track)("INTERNAL_VOLT_ERROR", {
                current_screen: routeId
            });
        }
    }
    if (modalOptions && (modalOptions === null || modalOptions === void 0 ? void 0 : modalOptions.disableDefault)) {
        return error;
    }
    if (route === "HANDLE") {
        return error;
    }
    else if (modalOptions && (modalOptions === null || modalOptions === void 0 ? void 0 : modalOptions.isPartnerPlatform)) {
        if (lodash_1.default.get(error, 'response.status', false) ===
            403 ||
            lodash_1.default.get(error, 'response.status', false) === 401) {
            const _user = JSON.parse(JSON.stringify(yield async_storage_1.default.getItem('user_context')));
            let partnerAccountType = undefined;
            if (_user) {
                if ((_user === null || _user === void 0 ? void 0 : _user.linkedPartnerAccounts) && (_user === null || _user === void 0 ? void 0 : _user.length) === 0) {
                    if (_user === null || _user === void 0 ? void 0 : _user.linkedPartnerAccounts[0]) {
                        partnerAccountType = (_a = _user.linkedPartnerAccounts[0]) === null || _a === void 0 ? void 0 : _a.partnerAccountType;
                    }
                }
            }
            yield async_storage_1.default.removeItem('access_token');
            yield async_storage_1.default.removeItem('accessToken');
            yield async_storage_1.default.removeItem('user_context');
            if (react_native_1.Platform.OS === 'web' || (0, utils_1.isFromAndroidWebview)()) {
                const url = window.location.href;
                switch (partnerAccountType) {
                    case 'AFFILIATE':
                        window.open(`/partner/affiliate_signup/${(0, utils_1.getParamsLink)(url)}`, '_self');
                        break;
                    default:
                        window.open(`/partner/signup/${(0, utils_1.getParamsLink)(url)}`, '_self');
                        break;
                }
            }
        }
        return error;
    }
    if (callbackBeforeErrorHandle) {
        yield callbackBeforeErrorHandle();
    }
    const width = modalOptions && modalOptions.width
        ? modalOptions.width
        : '100%';
    if (lodash_1.default.get(error, 'response.status', false) ===
        403 ||
        lodash_1.default.get(error, 'response.status', false) === 401) {
        yield async_storage_1.default.removeItem('access_token');
        yield async_storage_1.default.removeItem('accessToken');
        yield async_storage_1.default.removeItem("application_id");
        yield async_storage_1.default.removeItem('isPledgeFirstTime');
        yield (0, root_navigation_1.navigateWithReset)('PHONE_NUMBER');
    }
    else if (lodash_1.default.get(error, 'response.status', false) === 400
        && (!((_d = (_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.voltErrorCode) === null || _d === void 0 ? void 0 : _d.includes("ACCOUNT_BLOCKED_FROM_OTP"))
            && !((_g = (_f = (_e = error === null || error === void 0 ? void 0 : error.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.voltErrorCode) === null || _g === void 0 ? void 0 : _g.includes("IN_CORRECT_OTP")))
        && !((_k = (_j = (_h = error === null || error === void 0 ? void 0 : error.response) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.voltErrorCode) === null || _k === void 0 ? void 0 : _k.includes("IN_CORRECT_PLATFORM_LOGIN"))
        && !((_o = (_m = (_l = error === null || error === void 0 ? void 0 : error.response) === null || _l === void 0 ? void 0 : _l.data) === null || _m === void 0 ? void 0 : _m.voltErrorCode) === null || _o === void 0 ? void 0 : _o.includes("INCORRECT_PASSWORD_FOR_PARTNER"))
        && !((_r = (_q = (_p = error === null || error === void 0 ? void 0 : error.response) === null || _p === void 0 ? void 0 : _p.data) === null || _q === void 0 ? void 0 : _q.voltErrorCode) === null || _r === void 0 ? void 0 : _r.includes("PARTNER_ACCOUNT_NOT_FOUND"))
        && !((_u = (_t = (_s = error === null || error === void 0 ? void 0 : error.response) === null || _s === void 0 ? void 0 : _s.data) === null || _t === void 0 ? void 0 : _t.voltErrorCode) === null || _u === void 0 ? void 0 : _u.includes("BAD_REQUEST_PHOTO_MISMATCH"))
        && !((_x = (_w = (_v = error === null || error === void 0 ? void 0 : error.response) === null || _v === void 0 ? void 0 : _v.data) === null || _w === void 0 ? void 0 : _w.voltErrorCode) === null || _x === void 0 ? void 0 : _x.includes("DIGIO_PAN_MISMATCH"))
        && route !== "BANK_ACCOUNT_VERIFICATION") {
        if ((((_0 = (_z = (_y = error === null || error === void 0 ? void 0 : error.response) === null || _y === void 0 ? void 0 : _y.data) === null || _z === void 0 ? void 0 : _z.voltErrorCode) === null || _0 === void 0 ? void 0 : _0.includes("MF_NO_ACCOUNT_FOUND_MATCHING_DETAILS")) && route === "HANDLE")
            || ((_3 = (_2 = (_1 = error === null || error === void 0 ? void 0 : error.response) === null || _1 === void 0 ? void 0 : _1.data) === null || _2 === void 0 ? void 0 : _2.voltErrorCode) === null || _3 === void 0 ? void 0 : _3.includes("IFSC_INELIGIBLE_FOR_AUTOPAY"))
            || (lodash_1.default.get(error, 'response.data.voltErrorCode', false) === "KYC_VERIFICATION_FAILED_NAME_MISMATCH_DIGIO")
            || (lodash_1.default.get(error, 'response.data.voltErrorCode', false) === "BAD_REQUEST_PHOTO_MISMATCH")
            || (lodash_1.default.get(error, 'response.data.voltErrorCode', false) === "DIGIO_PAN_MISMATCH")
            || (lodash_1.default.get(error, 'response.data.voltErrorCode', false) === "NO_FORECLOSURE_REQUEST_FOUND")
            || route === "BANK_ACCOUNT_VERIFICATION") {
            return error;
        }
        yield (0, root_navigation_1.goToRoute)('ALERT_PAGE', {
            alertProps: {
                id: 'bt_panVerification_editDetails',
                iconName: 'Failed',
                title: 'Verification failed!',
                subTitle: lodash_1.default.get(error, 'response.data.message'),
                type: 'DEFAULT',
                ctaLabel: 'Edit Details',
                primary: true,
                width: width,
                ctaAction: {
                    type: 'CLOSE_POPUP',
                    routeId: 'ALERT_PAGE',
                    payload: {},
                },
            },
        });
    }
    else if (lodash_1.default.get(error, 'response.status', false) === 500) {
        // @ts-ignore
        if ((url === null || url === void 0 ? void 0 : url.slice(-17)) === "app/borrower/user") {
            return (0, root_navigation_1.goToRoute)('USER_CONTEXT_500');
        }
        else {
            yield (0, root_navigation_1.goToRoute)('ALERT_PAGE', {
                alertProps: {
                    type: 'DEFAULT',
                    iconName: 'Alert',
                    subTitle: lodash_1.default.get(error, 'response.data.message'),
                    title: 'Sorry something went wrong',
                    ctaLabel: 'Okay',
                    width: width,
                    ctaAction: {
                        type: 'CLOSE_POPUP',
                        routeId: 'ALERT_PAGE',
                        payload: {},
                    },
                },
            });
        }
    }
    else {
        if (!((_6 = (_5 = (_4 = error === null || error === void 0 ? void 0 : error.response) === null || _4 === void 0 ? void 0 : _4.data) === null || _5 === void 0 ? void 0 : _5.voltErrorCode) === null || _6 === void 0 ? void 0 : _6.includes("ACCOUNT_BLOCKED_FROM_OTP"))
            && !((_9 = (_8 = (_7 = error === null || error === void 0 ? void 0 : error.response) === null || _7 === void 0 ? void 0 : _7.data) === null || _8 === void 0 ? void 0 : _8.voltErrorCode) === null || _9 === void 0 ? void 0 : _9.includes("IN_CORRECT_OTP"))
            && !((_12 = (_11 = (_10 = error === null || error === void 0 ? void 0 : error.response) === null || _10 === void 0 ? void 0 : _10.data) === null || _11 === void 0 ? void 0 : _11.voltErrorCode) === null || _12 === void 0 ? void 0 : _12.includes("IN_CORRECT_PLATFORM_LOGIN"))
            && !((_15 = (_14 = (_13 = error === null || error === void 0 ? void 0 : error.response) === null || _13 === void 0 ? void 0 : _13.data) === null || _14 === void 0 ? void 0 : _14.voltErrorCode) === null || _15 === void 0 ? void 0 : _15.includes("INCORRECT_PASSWORD_FOR_PARTNER"))
            && !((_18 = (_17 = (_16 = error === null || error === void 0 ? void 0 : error.response) === null || _16 === void 0 ? void 0 : _16.data) === null || _17 === void 0 ? void 0 : _17.voltErrorCode) === null || _18 === void 0 ? void 0 : _18.includes("PARTNER_ACCOUNT_NOT_FOUND"))
            && !((_21 = (_20 = (_19 = error === null || error === void 0 ? void 0 : error.response) === null || _19 === void 0 ? void 0 : _19.data) === null || _20 === void 0 ? void 0 : _20.voltErrorCode) === null || _21 === void 0 ? void 0 : _21.includes("DIGIO_PAN_MISMATCH"))
            && !((_24 = (_23 = (_22 = error === null || error === void 0 ? void 0 : error.response) === null || _22 === void 0 ? void 0 : _22.data) === null || _23 === void 0 ? void 0 : _23.voltErrorCode) === null || _24 === void 0 ? void 0 : _24.includes("MF_NO_ACCOUNT_FOUND_MATCHING_DETAILS"
                && (lodash_1.default.get(error, 'response.data.voltErrorCode', false) !== "KYC_VERIFICATION_FAILED_NAME_MISMATCH_DIGIO")
                && route !== "HANDLE"))) {
            if (lodash_1.default.get(error, 'response.data.voltErrorCode', false) === "KYC_VERIFICATION_FAILED_NAME_MISMATCH_DIGIO" ||
                lodash_1.default.get(error, 'response.data.voltErrorCode', false) === "BAD_REQUEST_PHOTO_MISMATCH" ||
                lodash_1.default.get(error, 'response.data.voltErrorCode', false) === "DIGIO_PAN_MISMATCH") {
                return error;
            }
            const message = lodash_1.default.get(error, 'message', '');
            yield (0, root_navigation_1.goToRoute)('ALERT_PAGE', {
                alertProps: {
                    id: 'bt_panVerification_editDetails',
                    title: 'Verification failed!',
                    subTitle: message,
                    iconName: 'Alert',
                    type: 'DEFAULT',
                    ctaLabel: 'Edit Details',
                    primary: true,
                    width: width,
                    ctaAction: {
                        type: 'CLOSE_POPUP',
                        routeId: 'ALERT_PAGE',
                        payload: {},
                    },
                },
            });
        }
    }
    return error;
});
const digio = {
    init() {
        utils_1.digioUtils.init();
    },
    submit(requestId, identifier, token_id) {
        utils_1.digioUtils.submit(requestId, identifier, token_id);
    },
};
exports.network = {
    get(url, config, callbackBeforeErrorHandle, modalOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            return axios_1.default
                .get(url, config)
                .then((response) => __awaiter(this, void 0, void 0, function* () {
                if ((0, utils_1.isEncrypted)(url)) {
                    response.data = JSON.parse(yield (0, utils_1.decrypt)(response.data.result));
                }
                return response;
            }))
                .catch((error) => __awaiter(this, void 0, void 0, function* () {
                if ((0, utils_1.isEncrypted)(url) &&
                    error.response &&
                    error.response.data &&
                    error.response.data.result) {
                    error.response.data = JSON.parse(yield (0, utils_1.decrypt)(error.response.data.result));
                }
                return yield handleError(error, modalOptions, callbackBeforeErrorHandle, (config === null || config === void 0 ? void 0 : config.handleFromMF) ? "HANDLE" : "");
            }));
        });
    },
    post(url, data, config, callbackBeforeErrorHandle, modalOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            if ((0, utils_1.isEncrypted)(url)) {
                data = {
                    encryptedRequest: yield (0, utils_1.encrypt)(JSON.stringify(data)),
                };
            }
            return axios_1.default
                .post(url, data, config)
                .then((response) => __awaiter(this, void 0, void 0, function* () {
                if ((0, utils_1.isEncrypted)(url)) {
                    response.data = JSON.parse(yield (0, utils_1.decrypt)(response.data.result));
                }
                return response;
            }))
                .catch((error) => __awaiter(this, void 0, void 0, function* () {
                if ((0, utils_1.isEncrypted)(url) &&
                    error.response &&
                    error.response.data &&
                    error.response.data.result) {
                    error.response.data = JSON.parse(yield (0, utils_1.decrypt)(error.response.data.result));
                }
                return yield handleError(error, modalOptions, callbackBeforeErrorHandle, (config === null || config === void 0 ? void 0 : config.handleFromMF) ? "HANDLE" : "", url);
            }));
        });
    },
    put(url, data, config, callbackBeforeErrorHandle, modalOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            if ((0, utils_1.isEncrypted)(url)) {
                data = {
                    encryptedRequest: yield (0, utils_1.encrypt)(JSON.stringify(data)),
                };
            }
            return axios_1.default
                .put(url, data, config)
                .then((response) => __awaiter(this, void 0, void 0, function* () {
                if ((0, utils_1.isEncrypted)(url)) {
                    response.data = JSON.parse(yield (0, utils_1.decrypt)(response.data.result));
                }
                return response;
            }))
                .catch((error) => __awaiter(this, void 0, void 0, function* () {
                if ((0, utils_1.isEncrypted)(url) &&
                    error.response &&
                    error.response.data &&
                    error.response.data.result) {
                    error.response.data = JSON.parse(yield (0, utils_1.decrypt)(error.response.data.result));
                }
                return yield handleError(error, modalOptions, callbackBeforeErrorHandle);
            }));
        });
    },
    patch(url, data, config, callbackBeforeErrorHandle, modalOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            if ((0, utils_1.isEncrypted)(url)) {
                data = {
                    encryptedRequest: yield (0, utils_1.encrypt)(JSON.stringify(data)),
                };
            }
            return axios_1.default
                .patch(url, data, config)
                .then((response) => __awaiter(this, void 0, void 0, function* () {
                if ((0, utils_1.isEncrypted)(url)) {
                    response.data = JSON.parse(yield (0, utils_1.decrypt)(response.data.result));
                }
                return response;
            }))
                .catch((error) => __awaiter(this, void 0, void 0, function* () {
                if ((0, utils_1.isEncrypted)(url) &&
                    error.response &&
                    error.response.data &&
                    error.response.data.result) {
                    error.response.data = JSON.parse(yield (0, utils_1.decrypt)(error.response.data.result));
                }
                return yield handleError(error, modalOptions, callbackBeforeErrorHandle, (config === null || config === void 0 ? void 0 : config.handleFromMF) ? "HANDLE" : "");
            }));
        });
    },
    delete(url, config, callbackBeforeErrorHandle, modalOptions) {
        return axios_1.default
            .delete(url, config)
            .catch((error) => handleError(error, modalOptions, callbackBeforeErrorHandle));
    },
    postForm(url, data, config, callbackBeforeErrorHandle, modalOptions) {
        return axios_1.default
            .postForm(url, data, config)
            .catch((error) => handleError(error, modalOptions, callbackBeforeErrorHandle));
    },
    putForm(url, data, config, callbackBeforeErrorHandle, modalOptions) {
        return axios_1.default
            .postForm(url, data, config)
            .catch((error) => handleError(error, modalOptions, callbackBeforeErrorHandle));
    },
    patchForm(url, data, config, callbackBeforeErrorHandle, modalOptions) {
        return axios_1.default
            .postForm(url, data, config)
            .catch((error) => handleError(error, modalOptions, callbackBeforeErrorHandle));
    },
};
const standardUtilitiesRaw = (state, setDataStoreInPath, appendWidgets, removeWidgets, routeId, heightScreen, widthScreen, extraProps) => ({
    openURL: (url) => __awaiter(void 0, void 0, void 0, function* () {
        const supported = yield react_native_1.Linking.canOpenURL(url);
        if (supported) {
            // Opening the link with some app, if the URL scheme is "http" the web link should be opened
            // by some browser in the mobile
            yield react_native_1.Linking.openURL(url);
        }
    }),
    clipboard: {
        set: (text) => __awaiter(void 0, void 0, void 0, function* () { return clipboard_1.default.setString(text); }),
        get: () => __awaiter(void 0, void 0, void 0, function* () { return yield clipboard_1.default.getString(); }),
    },
    network: exports.network,
    asyncStorage: {
        get: (key, callBack) => async_storage_1.default.getItem(key, callBack),
        set: (key, value, callBack) => async_storage_1.default.setItem(key, value, callBack),
        remove: (key, callBack) => async_storage_1.default.removeItem(key, callBack),
        clear: (callBack) => async_storage_1.default.clear(callBack),
    },
    getDatastore(path) {
        if (path) {
            return Promise.resolve((0, lodash_es_1.get)(state, path));
        }
        else {
            return state;
        }
    },
    getHeight() {
        return react_native_1.Platform.OS === 'ios' ? heightScreen - 10 : heightScreen;
    },
    scrollToIndex({ index, routeId, viewOffset, }) {
        let _ref = SharedPropsService_1.default.getWidgetRef(routeId);
        setTimeout(() => {
            index &&
                _ref.scrollToIndex({
                    index,
                    animated: true,
                    viewOffset,
                });
        }, 16);
    },
    setDatastore(routeId, widgetId, payload) {
        const updateDatastore = (resolve) => __awaiter(this, void 0, void 0, function* () {
            yield setDataStoreInPath({
                routeId,
                widgetId,
                payload,
            });
            resolve(state.datastore);
            // if (!isDiff(prevPayload.current, payload)) {
            // 	/*** If the payload is the same as the last payload, then we don't need to update the state */
            // 	console.info(
            // 		'*** [ Update Skipped ] ',
            // 		payload,
            // 	);
            // 	return;
            // }
            // const prevProps = get(
            // 	state,
            // 	`routeMap.${routeId}.template.datastore.${widgetId}`,
            // 	{},
            // );
            // if (isDiff(prevProps, payload)) {
            /*** If the payload is different from the last payload, then we need to update the state */
            // await setDataStoreInPath({
            // 	routeId,
            // 	widgetId,
            // 	payload,
            // });
            // resolve(state.datastore);
            // } else {
            // 	console.info(
            // 		'*** [ Update Skipped ] ',
            // 		payload,
            // 		'prevProps ',
            // 		prevProps,
            // 	);
            // }
            /*** save payload for next time compare */
            // prevPayload.current = payload;
        });
        return new Promise(updateDatastore);
    },
    appendWidgets(routeId, datastore, widgets, appendAfterWidgetId) {
        appendWidgets({
            routeId,
            datastore,
            widgets,
            appendAfterWidgetId,
        });
    },
    removeWidgets(routeId, widgets) {
        removeWidgets({
            routeId,
            widgets,
        });
    },
    /** todo **/
    reloadPage(reloadParams) { },
    /** todo **/
    showToast(toastProps) { },
    /** todo **/
    showLoader(loaderParams) { },
    /** todo **/
    hideLoader() { },
    showPopup(params) {
        return __awaiter(this, void 0, void 0, function* () {
            yield (0, root_navigation_1.goToRoute)('ALERT_PAGE', {
                alertProps: params,
            }, false, extraProps);
        });
    },
    hidePopup() {
        (0, root_navigation_1.goBack)();
    },
    navigate(routeId, params, shouldPush = false) {
        (0, root_navigation_1.goToRoute)(routeId, params, shouldPush, extraProps);
    },
    navigateWithClear(routeId, params) {
        (0, root_navigation_1.navigateWithClear)(routeId, params, false, extraProps);
    },
    /*
        This method will initialize amplitude sdk
    */
    initializeAmplitude(userId = '', token = '') {
        if (react_native_1.Platform.OS === 'web') {
            userId === '' ?
                amplitude_js_1.default.getInstance().init(token) :
                amplitude_js_1.default.getInstance().setUserId(userId);
        }
        else {
            userId === ''
                ? (0, analytics_react_native_1.init)(token)
                : (0, analytics_react_native_1.setUserId)(userId);
        }
    },
    initializeAmplitudeForPartner(userId = "", amplitudeKey = '') {
        if (react_native_1.Platform.OS === 'web') {
            // @ts-ignore
            userId === '' ? amplitude_js_1.default.getInstance().init(amplitudeKey) :
                amplitude_js_1.default.getInstance().setUserId(userId);
        }
        else {
            // @ts-ignore
            userId === "" ? (0, analytics_react_native_1.init)(amplitudeKey) : (0, analytics_react_native_1.setUserId)(userId);
        }
    },
    initializeAmplitudeWithDeviceID(deviceId = '') {
        if (react_native_1.Platform.OS === 'web') {
            amplitude_js_1.default.getInstance().setDeviceId(deviceId);
        }
        else {
            (0, analytics_react_native_1.setDeviceId)(deviceId);
        }
    },
    getAmplitudeDeviceID() {
        if (react_native_1.Platform.OS === 'web') {
            return amplitude_js_1.default.getInstance().options.deviceId;
        }
        else {
            return (0, analytics_react_native_1.getDeviceId)();
        }
    },
    /*
    This method will instrument track
    */
    instrumentTrack(event, params) {
        if (react_native_1.Platform.OS === 'web') {
            amplitude_js_1.default.getInstance().logEvent(event, params);
        }
        else {
            (0, analytics_react_native_1.track)(event, params);
        }
    },
    /*
    This method will assign user property
   */
    addUseProperty(key, value) {
        if (react_native_1.Platform.OS === "web") {
            const identify = new amplitude_js_1.default.Identify();
            identify.setOnce(key, value);
            amplitude_js_1.default.getInstance().identify(identify);
        }
        else {
            const identifyObj = new analytics_react_native_2.Identify();
            identifyObj.setOnce(key, value);
            (0, analytics_react_native_2.identify)(identifyObj);
        }
    },
    navigateToBase(routeId, params) {
        (0, root_navigation_1.navigateWithReset)(routeId, params, extraProps);
    },
    goBack: root_navigation_1.goBack,
    handleError,
    openNewTab(url, targetType = types_1.OpenNewTabTargetType.blank, config = {
        width: 600,
        height: 600,
        target: 'Volt Money',
    }) {
        if (url.includes("mailto:")) {
            (0, analytics_react_native_1.track)("CONTACT_VIA_EMAIL_BUTTON_CLICKED");
        }
        if (url.includes("wa.me")) {
            (0, analytics_react_native_1.track)("CONTACT_VIA_WA_BUTTON_CLICKED");
        }
        if (url.includes("tel")) {
            (0, analytics_react_native_1.track)("CONTACT_VIA_CALL_BUTTON_CLICKED");
        }
        switch (react_native_1.Platform.OS) {
            case 'web': {
                if (targetType === types_1.OpenNewTabTargetType.popup &&
                    config &&
                    config.width &&
                    config.height &&
                    config.target) {
                    const left = screen.width / 2 - config.width / 2;
                    const top = screen.height / 2 - config.height / 2;
                    window.open(url, `${config.target}`, `height=${config.height},width=${config.width}. top=${top}, left=${left}`);
                }
                else {
                    window.open(url, targetType);
                }
                break;
            }
            case 'android':
            case 'ios': {
                react_native_1.Linking.openURL(url);
            }
        }
    },
    analytics: (eventId, params, eventType = types_1.AnalyticsEventType.EventTracking) => {
        console.warn('Analytics method called', react_native_1.Platform.OS);
        react_native_1.Platform.OS === 'web' &&
            utils_1.GoogleAnalytics.sendEvent(eventId, params, eventType);
    },
    digio,
    importScript: (resourceUrl, customFunction, successCb, failureCb, origin) => {
        (0, utils_1.ImportScript)(resourceUrl, customFunction, successCb, failureCb, origin);
    },
    showVerticalScroll: () => {
        return (0, utils_1.PlatformSpecificScroll)();
    },
    metaData: {
        platform: {
            OS: react_native_1.Platform.OS,
            Version: react_native_1.Platform.Version,
        },
        widgetId: '',
        routeId: '',
        /*** @todo: add actual width and height window size */
        width: 0,
        height: 0,
        heightScreen: heightScreen,
        widthScreen: widthScreen - 32,
        /*** @todo: add more meta data */
    },
});
exports.standardUtilitiesRaw = standardUtilitiesRaw;
//# sourceMappingURL=standardUtility.js.map